import { occurrenceType, plannerEvent } from  '@/interfaces/planner';


const EventDate = ({event}:{event:plannerEvent}) => {

    function hourFormatter(date:Date){

        const parsedDate = new Date(date);

        const ampm = parsedDate.getHours() >= 12 ? 'PM' : 'AM';

        return `${String(parsedDate.getHours()).padStart(2, '0')}:${String(parsedDate.getMinutes()).padStart(2, '0')}${ampm}`
    }

    if (event.occurrence.span){
        return null
    }

    if ([occurrenceType.AllDay, occurrenceType.AllDayConfigurable].includes(event.occurrence.occurrenceType)){
        return (
            <span>
                All Day
            </span>
        )
    }

    return (      
        <span style={{textDecoration: event.isCancelled ? 'line-through' : ''}}>{hourFormatter(event.occurrence.start)} - {hourFormatter(event.occurrence.end)}</span>
    );
};

export default EventDate;